<app-sales-credit-number [creditNumber]="request?.number" [data]="request" *ngIf="categoryCode !== 'kredicash' "></app-sales-credit-number>
<ng-container *ngIf="request">
  <!-- <div class="container section__creditResume h-full" >
    <div class="wrapper">
      <div class="sectionContainer fadeinright animation-duration-200">
        <article>
          <div class="mainInfo">
            <i class="mainIcon mainIcon--amount">
              <svg width="68" height="55" viewBox="0 0 68 55" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path class="svgPath--primary" d="M27.1125 0C12.2444 0 0 12.2444 0 27.1125C0 41.9807 12.2444 54.2251 27.1125 54.2251C42.1994 54.2251 54.2251 41.9807 54.2251 27.1125C54.2251 12.2444 42.1994 0 27.1125 0ZM27.1125 49.8521C14.6495 49.8521 4.37299 39.7942 4.37299 27.1125C4.37299 14.6495 14.4309 4.37299 27.1125 4.37299C39.5756 4.37299 49.8521 14.4309 49.8521 27.1125C49.8521 39.7942 39.7942 49.8521 27.1125 49.8521Z" fill="#000"/>
                <path class="svgPath--primary" d="M24.9261 20.3344H33.8908C35.2027 20.3344 36.0773 19.2411 36.0773 18.1479C36.0773 16.836 34.984 15.9614 33.8908 15.9614H29.2991V13.7749C29.2991 12.463 28.2059 11.5884 27.1126 11.5884C25.8007 11.5884 24.9261 12.6816 24.9261 13.7749V15.9614C21.2091 15.9614 18.148 19.0225 18.148 22.7395C18.148 26.4566 21.2091 29.5177 24.9261 29.5177H29.5178C30.8297 29.5177 31.7043 30.6109 31.7043 31.7042C31.7043 33.0161 30.611 33.8907 29.5178 33.8907H20.3345C19.0226 33.8907 18.148 34.9839 18.148 36.0771C18.148 37.1704 19.2413 38.2636 20.3345 38.2636H24.9261V40.4501C24.9261 41.762 26.0194 42.6366 27.1126 42.6366C28.4245 42.6366 29.2991 41.5434 29.2991 40.4501V38.2636C33.0162 38.2636 36.0773 35.2025 36.0773 31.4855C36.0773 27.7685 33.0162 24.7074 29.2991 24.7074H24.7075C23.3956 24.7074 22.521 23.6141 22.521 22.5209C22.7397 21.4276 23.6143 20.3344 24.9261 20.3344Z" fill="#000"/>
                <path class="svgPath--secondary" d="M63.4081 40.8875H55.7554C53.5689 45.2605 50.5078 49.1962 46.7908 52.2573H63.4081C65.8133 52.2573 67.9998 50.2894 67.9998 47.6656V45.4791C67.9998 42.8553 66.0319 40.8875 63.4081 40.8875Z" fill="#000"/>
                <path class="svgPath--secondary" d="M63.4081 27.1126H58.8165C58.8165 31.0483 57.9419 34.984 56.63 38.4824H63.1895C65.5946 38.4824 67.7811 36.5145 67.7811 33.8907V31.7042C67.9998 29.2991 66.0319 27.1126 63.4081 27.1126Z" fill="#000"/>
                <path class="svgPath--secondary" d="M63.4084 13.5563H55.7556C57.5048 17.0547 58.3794 20.7717 58.8167 24.9261H63.4084C65.8135 24.9261 68 22.9582 68 20.3344V18.1479C68 15.5241 66.0322 13.5563 63.4084 13.5563Z" fill="#000"/>
              </svg>
            </i>
            <h1 class="h1--bg">¡Excelente!</h1>
            <p>
              {{ 'Mira cómo quedaría tu crédito:' | termReplace }}
            </p>
          </div>

          <div class="backgroundArrow">
            <div class="arrowSvg">
              <svg width="55" height="39" viewBox="0 0 55 39" fill="none" xmlns="http://www.w3.org/2000/svg">
                <g opacity="0.5">
                  <path d="M29.4555 16.4348L18.4474 4.89504C16.9489 3.32418 14.4589 3.27616 12.8745 4.78756L1.23526 15.8906C-0.349133 17.402 -0.418519 19.8915 1.07997 21.4624L12.0881 33.0021C13.5866 34.573 16.0766 34.621 17.661 33.1096L29.3002 22.0066C30.8846 20.4952 30.954 18.0057 29.4555 16.4348ZM16.3354 31.72C15.5432 32.4757 14.2389 32.4505 13.4897 31.6651L2.48155 20.1253C1.73231 19.3399 1.76865 18.0359 2.56085 17.2802L14.2001 6.17717C14.9923 5.42146 16.2966 5.44662 17.0458 6.23205L28.054 17.7718C28.8032 18.5572 28.7669 19.8613 27.9747 20.617L16.3354 31.72Z" fill="#BCBCC2" />
                  <path d="M31.98 36.529L18.2631 22.1496C16.4188 20.2163 16.447 17.0736 18.458 15.1553L32.9004 1.37823C34.8504 -0.481957 37.9942 -0.480633 39.8962 1.51315L53.5555 15.8321C55.3998 17.7655 55.3715 20.9082 53.3605 22.8265L38.9182 36.6035C36.9648 38.5823 33.8243 38.4624 31.98 36.529Z" fill="#BCBCC2" />
                </g>
                <path class="svgStroke--secondary" d="M35 16L27.5 22.8182L20 16" stroke="#000" stroke-width="3" stroke-linecap="round" stroke-linejoin="round" />
              </svg>
            </div>
          </div>

          <div class="resumeBox">
            <div class="credit mb-20" *ngIf="topUpLoan.current_loan">
              <h2>{{ 'Recuerda que en tu crédito actual:' | termReplace }}</h2>
              <p>El valor de la cuota es <strong>{{topUpLoan.current_loan.quota_amount ??  0 | currency}}</strong> y te queda pendiente por pagar <strong>{{topUpLoan.current_loan.balance ?? 0 | currency}}</strong>.</p>
            </div>

            <div class="creditConsolidation mb-40" *ngIf="topUpLoan.consolidation">
              <div class="creditConsolidation__content">
                <h2>{{ 'Consolidación del crédito' | termReplace }}</h2>
                <div class="creditConsolidation__items">
                  <ul>
                    <li>
                      <div class="title">{{ 'Crédito anterior' | termReplace }}</div>
                      <div class="value">+ {{topUpLoan.current_loan.balance ?? 0 | currency}}</div>
                    </li>
                    <li>
                      <div class="title">{{ 'Crédito nuevo' | termReplace }}</div>
                      <div class="value">+ {{topUpLoan.consolidation.total_new_credit | currency}}</div>
                    </li>
                    <li>
                      <div class="title">Descuento</div>
                      <div class="value">- {{topUpLoan.consolidation.discount  | currency}}</div>
                    </li>
                    <li class="finalItem">
                      <div class="title">Monto a financiar</div>
                      <div class="value">{{topUpLoan.consolidation.total_financed | currency}}</div>
                    </li>
                  </ul>
                </div>
              </div>
            </div>

            <div class="product mb-15">
              <h2>{{ 'Con tu nuevo crédito te llevarás:' | termReplace }}</h2>

              <div class="product__item">
                <div class="productListItem__cont">
                  <div class="img">
                    <img [src]="extractCategoryIcon(request?.category_id)" [alt]="request.product?.name">
                  </div>
                  <div class="info">
                    <div class="title">
                      <h3>
                        {{request.product?.name}}
                      </h3>
                    </div>
                    <div class="main-price" *ngIf=!macroFlowService.isExperanzaFlow(this.flowCode)>
                      <p>{{request.quotes.prices.selected | currency}}</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="credit mb-20" *ngIf="topUpLoan.new_loan">
              <p *ngIf=!macroFlowService.isExperanzaFlow(this.flowCode)>Vas a dar un abono de <strong>{{topUpLoan.new_loan.installment | currency}}</strong> y pagarás <strong>{{ topUpLoan.new_loan.quota_amount  | currency}} {{frecuencyText(topUpLoan.new_loan.frequency)}}</strong> durante <strong>{{ topUpLoan.new_loan.quota_quantity }} cuotas</strong>.</p>

              <p *ngIf=macroFlowService.isExperanzaFlow(this.flowCode)>Pagarás <strong>{{topUpLoan.new_loan.quota_amount | currency}}</strong> mensuales durante <strong>{{ topUpLoan.new_loan.quota_quantity }} cuotas</strong> descontado de tu boleta de pago de la ONP.</p>
            </div>

            <div class="generalButton" *ngIf="showChangeProductButton">
              <button pButton pRipple label="Cambiar producto" icon="pi pi-angle-left" iconPos="left" class="p-button-secondary p-button-raised p-button-rounded n-background min-pad" (click)="onGotoStep(request?.category_id, SalesWorkflowSteps['select-product'])"></button>
            </div>
          </div>
        </article>

        <footer>
          <div class="footer__content">
            <button pButton pRipple label="Si, estoy de acuerdo" class="p-button-primary p-button-raised p-button-rounded w-full" (click)="onNextStep()"></button>
          </div>
        </footer>
      </div>
    </div>
  </div> -->

  <div class="container section__creditResume h-full">
    <div class="wrapper">
      <div class="sectionContainer fadeinright animation-duration-200">
        <article class="pb-40">
          <div class="mainInfo pb-30">
            <i class="mainIcon mainIcon--amount">
              <svg width="68" height="55" viewBox="0 0 68 55" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path class="svgPath--primary" d="M27.1125 0C12.2444 0 0 12.2444 0 27.1125C0 41.9807 12.2444 54.2251 27.1125 54.2251C42.1994 54.2251 54.2251 41.9807 54.2251 27.1125C54.2251 12.2444 42.1994 0 27.1125 0ZM27.1125 49.8521C14.6495 49.8521 4.37299 39.7942 4.37299 27.1125C4.37299 14.6495 14.4309 4.37299 27.1125 4.37299C39.5756 4.37299 49.8521 14.4309 49.8521 27.1125C49.8521 39.7942 39.7942 49.8521 27.1125 49.8521Z" fill="#000"/>
                <path class="svgPath--primary" d="M24.9261 20.3344H33.8908C35.2027 20.3344 36.0773 19.2411 36.0773 18.1479C36.0773 16.836 34.984 15.9614 33.8908 15.9614H29.2991V13.7749C29.2991 12.463 28.2059 11.5884 27.1126 11.5884C25.8007 11.5884 24.9261 12.6816 24.9261 13.7749V15.9614C21.2091 15.9614 18.148 19.0225 18.148 22.7395C18.148 26.4566 21.2091 29.5177 24.9261 29.5177H29.5178C30.8297 29.5177 31.7043 30.6109 31.7043 31.7042C31.7043 33.0161 30.611 33.8907 29.5178 33.8907H20.3345C19.0226 33.8907 18.148 34.9839 18.148 36.0771C18.148 37.1704 19.2413 38.2636 20.3345 38.2636H24.9261V40.4501C24.9261 41.762 26.0194 42.6366 27.1126 42.6366C28.4245 42.6366 29.2991 41.5434 29.2991 40.4501V38.2636C33.0162 38.2636 36.0773 35.2025 36.0773 31.4855C36.0773 27.7685 33.0162 24.7074 29.2991 24.7074H24.7075C23.3956 24.7074 22.521 23.6141 22.521 22.5209C22.7397 21.4276 23.6143 20.3344 24.9261 20.3344Z" fill="#000"/>
                <path class="svgPath--secondary" d="M63.4081 40.8875H55.7554C53.5689 45.2605 50.5078 49.1962 46.7908 52.2573H63.4081C65.8133 52.2573 67.9998 50.2894 67.9998 47.6656V45.4791C67.9998 42.8553 66.0319 40.8875 63.4081 40.8875Z" fill="#000"/>
                <path class="svgPath--secondary" d="M63.4081 27.1126H58.8165C58.8165 31.0483 57.9419 34.984 56.63 38.4824H63.1895C65.5946 38.4824 67.7811 36.5145 67.7811 33.8907V31.7042C67.9998 29.2991 66.0319 27.1126 63.4081 27.1126Z" fill="#000"/>
                <path class="svgPath--secondary" d="M63.4084 13.5563H55.7556C57.5048 17.0547 58.3794 20.7717 58.8167 24.9261H63.4084C65.8135 24.9261 68 22.9582 68 20.3344V18.1479C68 15.5241 66.0322 13.5563 63.4084 13.5563Z" fill="#000"/>
              </svg>
            </i>
            <h1>Resumen del crédito</h1>
          </div>

          <div class="resumeBox">
            <div class="product product--border mb-25">
              <h2 class="black">Producto seleccionado</h2>
              <div class="product__item">
                <div class="productListItem__cont">
                  <div class="img">
                    <img [src]="extractCategoryIcon(request?.category_id)" [alt]="request.product?.name">
                  </div>
                  <div class="info">
                    <div class="title">
                      <h3>{{request.product?.name}}</h3>
                    </div>
                    <div class="main-price">
                      <p>{{request.quotes.prices.selected | currency}}</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="creditSummary mb-25">
              <div class="creditSummary__title">
                <h2>¿Cómo quedaría tu crédito?</h2>
              </div>
              <div class="creditSummary__content">
                <div class="creditSummary__header">
                  <i><app-hand-money-simple-icon></app-hand-money-simple-icon></i>
                  <h3>Consolidación del crédito</h3>
                </div>

                <div class="creditSummary__items">
                  <ul>
                    <li>
                      <div class="item__content">
                        <div class="title">Crédito anterior</div>
                        <div class="value"><span class="highlight">+ {{topUpLoan.current_loan.balance ?? 0 | currency}}</span></div>
                      </div>
                    </li>
                    <li>
                      <div class="item__content">
                        <div class="title">Descuento por cancelación anticipada</div>
                        <div class="value">- {{topUpLoan.consolidation.discount  | currency}}</div>
                      </div>
                    </li>
                    <li class="sub">
                      <div class="item__content">
                        <div class="title">Subtotal saldo a consolidar</div>
                        <div class="value">{{ subtotalToConsolidate | currency }}</div>
                      </div>
                    </li>
                    <li>
                      <div class="item__content">
                        <div class="title">Valor financiado — nueva compra</div>
                        <div class="value"><span class="highlight">+ {{topUpLoan.consolidation.total_new_credit | currency}}</span></div>
                      </div>
                      <div class="item__desc">
                        <p>KrediYA pagará este valor al comercio por esta compra.</p>
                      </div>
                    </li>
                  </ul>
                </div>
              </div>
              <div class="creditSummary__total">
                <div class="title">Nuevo monto del crédito consolidado</div>
                <div class="value">
                  <i><app-circle-money-icon></app-circle-money-icon></i>
                  <span>{{topUpLoan.consolidation.total_financed | currency}}</span>
                </div>
              </div>
            </div>

            <div class="advancePayment mb-25" *ngIf="hasAdvancePayment">
              <div class="advancePayment__title">
                <h2>Anticipo en tienda hoy</h2>
              </div>

              <div class="advancePayment__content">
                <div class="value">
                  <h3>Valor que el cliente paga hoy como anticipo</h3>
                  <span>{{ topUpLoan.advance_payment | currency }}</span>
                </div>

                <div class="description">
                  <p>En esta operación no se requiere anticipo en tienda.</p>
                </div>
              </div>
            </div>

            <div class="creditConditions mb-25">
              <div class="creditConditions__title">
                <h2>Condiciones del crédito</h2>
              </div>

              <div class="creditConditions__content">
                <div class="items">
                  <div class="item">
                    <div class="item__content">
                      <div class="content">
                        <h3>Cuota {{ frecuencyTextSingular(topUpLoan.new_loan.frequency) }}</h3>
                        <span class="highlight">{{ topUpLoan.new_loan.quota_amount  | currency}}</span>
                      </div>
                    </div>
                  </div>

                  <div class="item">
                    <div class="item__content">
                      <div class="content">
                        <h3>Primera cuota</h3>
                        <span>{{ topUpLoan.first_payment_date | date:'longDate' }}</span>
                      </div>
                    </div>
                  </div>

                  <div class="item">
                    <div class="item__content">
                      <div class="content">
                        <h3>Plazo</h3>
                        <span>{{ topUpLoan.new_loan.quota_quantity }} cuotas</span>
                      </div>
                    </div>
                  </div>

                  <div class="item">
                    <div class="item__content">
                      <div class="content">
                        <h3>Frecuencia</h3>
                        <span>{{frecuencyTextSingular(topUpLoan.new_loan.frequency)}}</span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="creditInfo">
              <div class="title">
                <h2>Importante</h2>
              </div>
              <div class="msgAlert">
                <div class="msgAlert__title">
                  <i><app-alert-simple-icon></app-alert-simple-icon></i>
                  <h3>Tu crédito actual quedará cancelado</h3>
                </div>
                <div class="msgAlert__description">
                  <p>Al aceptar, el crédito anterior queda cancelado automáticamente. Solo existirá este nuevo crédito consolidado.</p>
                </div>
              </div>
            </div>
          </div>
        </article>

        <footer>
          <div class="footer__content flexColumn">
            <button pButton pRipple label="Cambiar producto" icon="pi pi-angle-left" iconPos="left" class="p-button-secondary p-button-raised p-button-rounded w-full n-background" (click)="onGotoStep(request?.category_id, SalesWorkflowSteps['select-product'])"></button>
            <button pButton pRipple label="Sí, estoy de acuerdo" class="p-button-primary p-button-raised p-button-rounded w-full" (click)="onNextStep()"></button>

            <!--TODO: pendiente retomar, con los pasos este boton tiene dificultad de operacion
            <div class="footer__float">
              <p-button label="Me gustaría probar otra configuración" icon="pi pi-angle-left" iconPos="left" [text]="true" [plain]="true" (onClick)="onGotoStep(SalesWorkflowSteps['select-quota'])"></p-button>
            </div>
-->
          </div>
        </footer>
      </div>
    </div>
  </div>
</ng-container>
